var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tv-border"},[_c('CastrVideoPlayer',{attrs:{"url":_vm.url}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }